export default "__VITE_ASSET__CK7IfMx5__";